<ng-container *transloco="let l">
  <ion-app>
    <ion-content class="app-content" [scrollEvents]="true">
      <app-header *ngIf="(isLoggedIn$ | async) && !hideNavbar" class="hide-if-mobile"></app-header>
      <ion-router-outlet [animated]="true" id="main"></ion-router-outlet>
      <app-fab-menu></app-fab-menu>
    </ion-content>
    <ng-container *ngIf="(isLoggedIn$ | async) && !hideNavbar">
      <ng-container *ngIf="activeNavBarItemsForNavBar$ | async as activeNavBarItemsForNavBar">
        <ng-container *ngLet="navBarPlace$ | async as navBarPlace">
          <ng-container *ngLet="navBarComputed$ | async as navBarComputed">
            <ion-header class="fade-in hide-if-desktop" *ngIf="navBarPlace === NavbarPosition.Top && navBarComputed">
              <app-navbar [items]="activeNavBarItemsForNavBar" (triggerAction)="triggerAction($event)"></app-navbar>
            </ion-header>
            <ion-footer
              class="fade-in hide-if-desktop"
              *ngIf="(navBarPlace === NavbarPosition.Bottom || navBarPlace === NavbarPosition.Default) && navBarComputed"
            >
              <app-navbar [items]="activeNavBarItemsForNavBar" (triggerAction)="triggerAction($event)"></app-navbar>
            </ion-footer>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </ion-app>
</ng-container>
